import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { Button, ReyPopper, IView } from '@framework-controls/core';
import { toNumber } from 'lodash';
import { strings } from 'src/localization';
import * as css from './MenuCart.module.scss';
import classNames from 'classnames';
import { IAppointmentState } from 'src/store/states';
import { Services, SpecData, ApptOps, UpdateApptOpsInp, OpType, VehData, DepartmentSpec, DeteremineDeptInp, ApptCust, invalidDates, Advisor, VehicleRecs, Recom, WebOp, CheckedRecom, ascCtaInteractionInput, ascElementConfigurationInput } from 'src/models';
import ServicesCard from 'src/components/Summary/ServicesCard/ServicesCard';
import { ComponentMapIds } from 'src/components/map';
import ErrorMessage from 'src/components/ErrorMessage/ErrorMessage';
import { ascCtaInteraction, getElementColor, ascElementConfiguration } from 'src/helpers/EventHelper/EventHelper';

export interface Iprops {
    recom: Recom[];
    cartOpenFlag: boolean;
    close: (e: any) => void;
    apptOps: ApptOps[];
    specData?: SpecData;
    transFlag: string;
    apptTrans: string;
    deptSpecs?: DepartmentSpec;
    gmRedeemAmt: string | undefined;
    gmDealerCanEarn: string | undefined;
    gmDealerCanRedeem: string | undefined;
    locale: string;
    UpdateApptOps: (inputOps: UpdateApptOpsInp[]) => void;
    toggleMenu: (id: string) => void;
    toggleWeOwe: (id: string) => void;
    toggleRecommended: (id: string) => void;
    toggleRecall: (id: string) => void;
    toggleItem: (id: string) => void;
    noServicesSelected?: (e: any) => void;
    clearCheckedWebOps: () => void;
    clearCheckedAdditionalServices: () => void;
    getAdditionalServices: (profileNum: string, store: string, branch: string) => void;
    getApptOps: (profileNum: string, store: string, branch: string, vehData?: VehData) => void;
    anchorEl: HTMLElement;
    theme: string;
    skipServicesFlag?: boolean;
    store: string;
    branch: string;
    specProfile: string;
    currentMainPane: string;
    skipServices: boolean;
    appointment: IAppointmentState;
    apptDept: string;
    selectedVehicle?: string;
    invalidDates: invalidDates[];
    invalidDatesDept: string;
    vehicles: VehicleRecs;
    apptAdvNum?: string;
    apptCust?: ApptCust;
    specDeptData: DepartmentSpec;
    lastDeptRan?: string;
    mainPaneViewOrder: IView[];
    deptChangeFlag?: boolean;
    getDeptSpecs: () => void;
    getRMTimes: (specProfile: string, selectedDate: string, selectedAdv: string, recallSelected: boolean) => void;
    clearRMTimes: () => void;
    pushToMainPanes: (inputView: IView) => void;
    determineDept: (id: DeteremineDeptInp) => void;
    clearInvalidDates: () => void;
    getInvalidDates: (pecProfile: string) => void;
    popFromMainPane: (id: string) => void;
    changeDeptFlag: (inp: boolean) => void;
    webOps: WebOp[];
    selectedRecoms: CheckedRecom[];
    setNoAutoRecall: (value: boolean) => void;
    noAutoRecall: boolean;
}

function parseMoney(numberString: string) {
    return toNumber(numberString.replace(/[^0-9.]+/g, ''));
}

const MenuCart = (props: Iprops) => {
    const [services, setServices] = useState<Services[]>();
    const [displayDeptChangeMessage, setDisplayDeptChangeMessage] = useState<boolean>(false);
    const [heldServices, setHeldServices] = useState<Services[]>();
    const [prevDept, setPrevDept] = useState<string>(props.apptDept);
    const [newDept, setNewDept] = useState<string>('');
    const [showTransRemoveWarning, setShowTransRemoveWarning] = useState(false);
    const noStartingAt = (props.theme === 'lexus' || props.theme === 'lexusMonogram') ? true : false;
    const [, setOneNoStartingAt] = useState(false);

    const deptChangeCloseHandler = useCallback((e:any) => {
        setDisplayDeptChangeMessage(false);
        props.close(e);
    }, [props.close]);

    const ref = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const handleClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                props.close(event);
            }
        };

        document.addEventListener('click', handleClick);

        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [ref, props.close, displayDeptChangeMessage]);

    let totalMinCost: string = '';
    let holdMinCost: number = 0;
    // if services have not been loaded
    if (!services) {
        const servicesArray: Services[] = [];
        props.apptOps?.forEach((apptOp) => {
            if (apptOp.id !== 'skipReason') {
                let range = strings.CallDealerForPricing;
                let itemCostLowString = '****';
                if ((apptOp.itemCostLow !== '****') && (apptOp.itemCostLow !== '')) {
                    itemCostLowString = '$' + (Number(apptOp.itemCostLow) / 100).toFixed(2);
                }
                let itemCostHighString = '****';
                if ((apptOp.itemCostHigh !== '****') && (apptOp.itemCostHigh !== '')) {
                    itemCostHighString = '$' + (Number(apptOp.itemCostHigh) / 100).toFixed(2);
                }
                if (apptOp.itemCostHigh === ''|| apptOp.itemCostHigh === undefined) {
                    if (noStartingAt && (apptOp.opType === 6 || apptOp.opType === 1)) {
                        range = itemCostLowString;
                        if ((apptOp.itemCostHigh === '' || apptOp.itemCostHigh === undefined) &&
                            !apptOp.itemCostLow?.includes('*')) {
                            setOneNoStartingAt(true);
                        }
                    } else {
                        range = strings.StartingAt + ' ' + itemCostLowString;
                    }
                }
                if (apptOp.itemCostLow === '') {
                    range = strings.UpTo + ' ' + itemCostHighString;
                }
                if ((apptOp.itemCostLow !== '') &&
                    (apptOp.itemCostLow !== '****') &&
                    (apptOp.itemCostHigh !== '') &&
                    (apptOp.itemCostHigh !== '****')) {
                    range = itemCostLowString + ' - ' + itemCostHighString;
                }
                if ((apptOp.itemCostHigh === apptOp.itemCostLow) &&
                    (apptOp.itemCostLow !== '****') &&
                    (apptOp.itemCostHigh !== '****')) {
                    range = itemCostHighString;
                }

                // send email about this
                let webOpLangTitle = props.webOps.find(webOp => webOp.id === apptOp.operation)?.webTitleEN;
                if (props.locale === 'fr-CA') {
                    webOpLangTitle = props.webOps.find(webOp => webOp.id === apptOp.operation)?.webTitleFR;
                }

                let serviceName = webOpLangTitle ? webOpLangTitle : apptOp.concern;

                if (props.specData?.hidePriceLabel && ((apptOp.itemCostLow === '' && apptOp.itemCostHigh === '') ||
                    (apptOp.itemCostLow === '****' || apptOp.itemCostHigh === '****'))) {
                    range = '';
                    serviceName = `${serviceName}*`;
                }

                if (props.specData?.hidePriceLabel && apptOp.itemCostLow === '') {
                    serviceName = `${serviceName}*`;
                }

                servicesArray.push({
                    serviceName: serviceName,
                    id: apptOp.id,
                    priceHigh: itemCostHighString,
                    priceLow: itemCostLowString,
                    range: range,
                });
            }
        });
        setServices(servicesArray);
    } else {
        services.forEach((service) => {
            if (service.priceLow && (service.priceLow !== '****') && (totalMinCost !== '****')) {
                const itemCostLowNum = parseMoney(service.priceLow);
                holdMinCost += itemCostLowNum;
                totalMinCost = holdMinCost.toString();
            } else {
                totalMinCost = '****';
            }
        });
    }

    const removeApptOps = useCallback((servicesCopy: Services[]) => {
        // Need to readjust writeYourOwn ids in case one has been deleted
        let writeYourOwnCount = 0;
        servicesCopy?.forEach((service) => {
            if (service.id.substr(0, 9) === 'diagnosis') {
                service.id = 'diagnosis' + writeYourOwnCount;
                writeYourOwnCount++;
            }
        });
        const opsArrayCopy: UpdateApptOpsInp[] = [...props.appointment.ApptOps];
        const opsArray: UpdateApptOpsInp[] = [];
        writeYourOwnCount = 0;
        opsArrayCopy.forEach((op) => {
            if (servicesCopy.find(svc => op.id === svc.id)) {
                // Need to readjust writeYourOwn ids in case one has been deleted
                if (op.opType === (OpType.WriteYourOwn || OpType.Diagnosis)) {
                    const opCopy = { ...op, id: 'diagnosis' + writeYourOwnCount };
                    opsArray.push(opCopy);
                    writeYourOwnCount++;
                } else {
                    opsArray.push(op);
                }
            } else {
                if (op.opType === OpType.MaintenanceMenu ||
                    op.opType === OpType.ConditionalMaintMenu) {
                    props.toggleMenu(op.menuID);
                }
                if (op.opType === OpType.WeOwe) {
                    props.toggleWeOwe(op.concern);
                }
                if (op.opType === OpType.Recall) {
                    props.toggleRecall(op.concern);
                    props.setNoAutoRecall(true);
                }
                if (op.opType === OpType.RecommendedService) {
                    props.toggleItem(op.operation);
                    props.toggleRecommended(op.operation);
                }
                if (op.opType === OpType.IndividualService) {
                    // Because there is crossover between Recommended Services and Individual Services we need to
                    // check if the Individual Service is one of those. We only toggle the checkedRecom if both are true
                    // otherwise we create a loop in state where it has items selected that have been removed from the
                    // MenuCart.
                    const checkedIndex = props.recom?.findIndex(result => result.opCode === op.operation);
                    const selectedIndex = props.selectedRecoms?.findIndex(result => result.opCode === op.operation);
                    if (checkedIndex !== -1 && selectedIndex !== -1) {
                        props.toggleRecommended(op.operation);
                    }
                    props.toggleItem(op.operation);
                }
                // SkipServiceReason does not exist in services but should not be deleted
                if (op.opType === OpType.SkipServiceReason) {
                    opsArray.push(op);
                }
            }
        });
        if (!opsArray?.find((op) => ((op.opType === 6 || op.opType === 1) && op.itemCostHigh === '' &&
            op.itemCostLow?.includes('*')))) {
            setOneNoStartingAt(false);
        }
        if (props.currentMainPane !== 'ServiceTab') {
            props.getApptOps(props.specProfile, props.store, props.branch);
        }
        props.UpdateApptOps(opsArray);
    }, [props.appointment.ApptOps,
        props.currentMainPane,
        props.UpdateApptOps,
        props.toggleMenu,
        props.toggleWeOwe,
        props.toggleRecall,
        props.setNoAutoRecall,
        props.toggleItem,
        props.toggleRecommended,
        props.recom,
        props.selectedRecoms,
        props.getApptOps,
        props.specProfile,
        props.store,
        props.branch]);

    const continueRemoveService = useCallback((id: string) => {
        const servicesCopy = services?.filter(service => service.id !== id);
        const defaultDept = {
            defaultDept: props.specData?.departmentFlag ?? '',
        };
        if (servicesCopy) {
            removeApptOps(servicesCopy);
        }
        props.determineDept(defaultDept);
        setServices(servicesCopy);
        props.getApptOps(props.specProfile, props.store, props.branch);
    }, [props.branch, props.determineDept, props.getApptOps, props.specData?.departmentFlag,
        props.specProfile, props.store, removeApptOps, services]);

    const removeService = useCallback((id: string, e: any) => {
        // if the trans type is rental or loaner then display warning message to explain that the service cannot be removed.
        // Also block the removal if we are currently on the CalendarSelect screen or QuickTimes screen.
        const rentalMinEstTimeCheck = (props.specData?.svcSpecs && props.specData?.svcSpecs?.rentalMinEst > 0) ||
            (props.specData?.bdySpecs && props.specData?.bdySpecs?.rentalMinEst > 0) ||
            (props.specData?.ossSpecs && props.specData?.ossSpecs?.rentalMinEst > 0);
        const loanerMinEstTimeCheck = (props.specData?.svcSpecs && props.specData?.svcSpecs?.loanerMinEst > 0) ||
            (props.specData?.bdySpecs && props.specData?.bdySpecs?.loanerMinEst > 0) ||
            (props.specData?.ossSpecs && props.specData?.ossSpecs?.loanerMinEst > 0);
        const rentalBlock = (props.transFlag === 'R' &&
            rentalMinEstTimeCheck);
        const loanerBlock = (props.transFlag === 'L' &&
            loanerMinEstTimeCheck);
        const screenBlock = (props.currentMainPane === 'CalendarSelect' || props.currentMainPane === 'QuickTime');
        if (rentalBlock || loanerBlock || screenBlock) {
            setShowTransRemoveWarning(true);

            return;
        }
        // If we have an advisor, an appointment date, or we are currently on the QuickTime or CalendarSelect pane,
        // we need to check if removing the service will cause a change in department.
        if (props.apptAdvNum || props.appointment.Appointment.date ||
            props.currentMainPane === 'QuickTime' || props.currentMainPane === 'CalendarSelect') {
            // First check if removing the service will cause a change in department.
            const newOps = props.apptOps.filter(op => op.id !== id);
            // Save the services array with the service removed for updating later if department change warning is necessary.
            setHeldServices(services?.filter(service => service.id !== id));
            // No need to check Department change if length of services is zero.
            if (newOps.length) {
                // Determine the department with the selected service removed.
                let workingDept = '';
                let varDepartment = props.specData?.departmentFlag ?? '';
                for (const x in newOps) {
                    const opDepartment = newOps[x].department;
                    switch (workingDept) {
                        case '':
                            workingDept = opDepartment;
                            break;
                        case opDepartment:
                            break;
                        default: {
                            if (props.specData?.svcSpecs) {
                                workingDept = 'S';
                            } else if (props.specData?.ossSpecs) {
                                workingDept = 'Q';
                            } else if (props.specData?.bdySpecs) {
                                workingDept = 'B';
                            }
                        }
                    }
                }
                if (workingDept !== '') {
                    varDepartment = workingDept;
                }
                setNewDept(varDepartment);
                if (varDepartment !== prevDept) {
                    // Display the Department Change warning.
                    setDisplayDeptChangeMessage(true);
                } else {
                    continueRemoveService(id);
                }
            } else {
                continueRemoveService(id);
            }
        } else {
            continueRemoveService(id);
        }
        const elementColor = getElementColor(e, 'color');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: 'x',
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: 'x',
            elementType: 'scheduling_tool',
            elementColor: elementColor,
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e);
    }, [props.specData?.svcSpecs,
        props.specData?.bdySpecs,
        props.specData?.ossSpecs,
        props.specData?.departmentFlag,
        props.transFlag,
        props.currentMainPane,
        props.apptAdvNum,
        props.appointment.Appointment.date,
        props.apptOps,
        services,
        prevDept,
        continueRemoveService,
        props.vehicles,
        props.selectedVehicle]);

    const recomTimes = useMemo (() => (
        {
            'S': props.specData?.svcSpecs?.recommTimes,
            'B': props.specData?.bdySpecs?.recommTimes,
            'Q': props.specData?.ossSpecs?.recommTimes,
        }
    ), [props.specData?.svcSpecs?.recommTimes,
        props.specData?.bdySpecs?.recommTimes,
        props.specData?.ossSpecs?.recommTimes]);

    const deptChangeContinueHandler = () => {
        setDisplayDeptChangeMessage(false);
        props.changeDeptFlag(true);
        // Close the menu cart.
        props.close('');
        // Remove the service from the appointment.
        const defaultDept = {
            defaultDept: props.specData?.departmentFlag ?? '',
        };
        if (heldServices) {
            removeApptOps(heldServices);
        }
        props.determineDept(defaultDept);
        setServices(heldServices);
        props.getApptOps(props.specProfile, props.store, props.branch);
        setHeldServices([]);
        props.getDeptSpecs();
        // If the current advisor is setup on the new department, there is no need to clear the advisor.
        let advisorChangeNeeded = true;
        let apptDeptAdvisors : Advisor[] = [];
        switch (newDept) {
            case 'B':
                apptDeptAdvisors = props.specData!.bdySpecs!.Advisors;
                break;
            case 'P':
                apptDeptAdvisors = props.specData!.pdiSpecs!.Advisors;
                break;
            case 'Q':
                apptDeptAdvisors = props.specData!.ossSpecs!.Advisors;
                break;
            default:
                apptDeptAdvisors = props.specData!.svcSpecs!.Advisors;
                break;
        }
        apptDeptAdvisors.forEach((advisor) => {
            if (advisor.advisorNum === props.apptAdvNum) {
                advisorChangeNeeded = false;
            }
        });
        if (advisorChangeNeeded) {
            props.clearInvalidDates();
            props.clearRMTimes();
            // If we are on the Summary screen, we need to pop the current pane before selecting a new date/time.
            const mainViewPanes = props.mainPaneViewOrder.map((view): IView => ({ ...view }));
            // This is the screen the user is on.
            const currentViewPanes = mainViewPanes[mainViewPanes.length - 1];
            if (currentViewPanes.viewId === ComponentMapIds.Summary) {
                props.popFromMainPane(currentViewPanes.viewId);
            }
            // Determine if we should move to QuickTime or CalendarSelect
            let skipQuickTimes = true;
            if (recomTimes[newDept] === 'Y' && props.apptCust?.custFirstName !== '' &&
                props.apptCust?.custNameId !== '') {
                skipQuickTimes = false;
            }
            if (skipQuickTimes) {
                props.pushToMainPanes({
                    viewId: ComponentMapIds.CalendarSelect,
                    component: ComponentMapIds.CalendarSelect,
                });
            } else {
                props.pushToMainPanes({
                    viewId: ComponentMapIds.QuickTime,
                    component: ComponentMapIds.QuickTime,
                });
            }
        }
        // Reset the previous department.
        setPrevDept(props.apptDept);
    };

    const closeEventHandler = useCallback((e: any) => {
        props.close(e);
        const elementColor = getElementColor(e, 'color');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.Close,
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [props.vehicles, props.selectedVehicle, props.close]);

    const closeMsgHandler = () => {
        setShowTransRemoveWarning(false);
    };

    const transRemoveErrMessage = () => {
        if (showTransRemoveWarning) {
            const screenBlock = (props.currentMainPane === 'CalendarSelect' || props.currentMainPane === 'QuickTime');
            const headerMsg = '';
            const errorMsg = screenBlock ? strings.TransRemoveSelTimeWarnMsg : strings.formatString(
                strings.TransRemoveWarnMsg, props.apptTrans).toString();
            const primaryMessage = strings.Okay;
            const secondaryMessage = '';

            return (
                <ErrorMessage
                    headerMsg={headerMsg}
                    errorMsg={errorMsg}
                    primaryBtnMessage={primaryMessage}
                    secondaryBtnMessage={secondaryMessage}
                    primaryHandler={closeMsgHandler}
                    secondaryHandler={closeMsgHandler}
                    closeHandler={closeMsgHandler}
                />
            );
        } else {
            return null;
        }
    };

    const transRemoveMessage = transRemoveErrMessage();

    const menuContentClasses = classNames(
        css.menuContent,
        {
            [css.menuMini]: props.theme === 'mini',
            [css.menuChevrolet]: props.theme === 'chevrolet',
            [css.menuBuick]: props.theme === 'buick',
            [css.menuMB]: props.theme === 'mercedesBenz',
        },
    );

    const selectServices = classNames(
        css.selectServices,
        {
            [css.selectServicesMini]: props.theme === 'audi',
            [css.selectServicesAlt]: props.theme === 'chevrolet' || props.theme === 'honda' || props.theme === 'buick' ||
                props.theme === 'infiniti' || props.theme === 'acura',
            [css.selectServicesBMW]: props.theme === 'bmw',
            [css.selectServicesSubaru]: props.theme === 'subaru',
            [css.selectServicesNissan]: props.theme === 'nissan',
            [css.selectServicesMB]: props.theme === 'mercedesBenz',
        },
    );

    const cartH4 = classNames(
        css.cartH4,
        {
            [css.audiCartH4]: props.theme === 'audi',
            [css.acuraCartH4]: props.theme === 'acura',
        },
    );

    const topLineCss = classNames(
        css.topline,
        {
            [css.toplineAudi]: props.theme === 'audi',
            [css.toplineBMW]: props.theme === 'bmw' || props.theme === 'mercedesBenz',
            [css.toplineSubaru]: props.theme === 'subaru',
        },
    );

    const closeLitStyles = classNames(
        css.closeLit,
        {
            [css.closeLitBMW]: props.theme === 'bmw',
            [css.closeLitHonda]: props.theme === 'honda',
            [css.closeLitFord]: props.theme === 'ford',
            [css.closeLitIN]: props.theme === 'infiniti',
            [css.closeLitMB]: props.theme === 'mercedesBenz',
            [css.closeLitAcura]: props.theme === 'acura',
        },
    );

    useEffect(() => {
        setPrevDept(props.apptDept);
    }, [props.apptDept]);

    const deptChangeErrMessage = () => {
        if (displayDeptChangeMessage) {
            const headerMsg = strings.DeptChangeWarning;
            const errorMsg = strings.DeptChangeMessage;
            const primaryMessage = strings.Continue;
            const secondaryMessage = strings.Cancel;

            return (
                <ErrorMessage
                    headerMsg={headerMsg}
                    errorMsg={errorMsg}
                    primaryBtnMessage={primaryMessage}
                    secondaryBtnMessage={secondaryMessage}
                    primaryHandler={deptChangeContinueHandler}
                    secondaryHandler={deptChangeCloseHandler}
                    closeHandler={deptChangeCloseHandler}
                />
            );
        } else {
            return null;
        }
    };

    const deptChangeMessage = deptChangeErrMessage();

    return (
        <div>
            <ReyPopper
                className={css.menuCartPane}
                transition
                placement='bottom-end'
                anchorEl={props.anchorEl}
                isOpen={props.cartOpenFlag}
            >
                {deptChangeMessage}
                <div className={menuContentClasses} ref={ref}>
                    <div className={topLineCss}></div>
                    <div className={css.innerDiv}>
                        {services?.length ? <ServicesCard
                            services={services!}
                            removeService={removeService}
                            totalMinCost={totalMinCost}
                            myCart={true}
                            theme={props.theme}
                            currentMainPane={props.currentMainPane}
                            gmRedeemAmt={props.gmRedeemAmt}
                            gmDealerCanEarn={props.gmDealerCanEarn}
                            gmDealerCanRedeem={props.gmDealerCanRedeem}
                            hidePriceLabel={props.specData?.hidePriceLabel}
                        /> :
                            <div className={css.noServiceDiv}>
                                <h4 className={cartH4}>{props.specData?.emptyCartMsg}</h4>
                                {props.currentMainPane !== 'AddVehicle' && !(props.skipServices)?
                                    <div>
                                        <span>{strings.Please}</span>
                                        <div id='noServices' onClick={props.noServicesSelected} className={selectServices}>
                                            {strings.NoServicesClickHere}
                                        </div>
                                        <div className={css.noServices}>{strings.ToSelectAService}</div>
                                    </div> : null
                                }
                            </div>
                        }
                        <div className={css.btnArea}>
                            <div style={{ margin: 'auto' }}>
                                <Button
                                    variant={'text'}
                                    id='cancelBtn'
                                    onClick={closeEventHandler}>
                                    <div className={closeLitStyles}>{strings.Close}</div>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={css.menuCartPane3} onClick={props.close} />
            </ReyPopper>
            <div className={css.menuCartPane2} onClick={props.close} />
            {transRemoveMessage}
        </div>
    );
};

export default MenuCart;